import { CheckboxGroup, Checkbox } from '@lmig/lmds-react-checkbox';
import { GridRow, GridCol } from '@lmig/lmds-react-grid';
import { IconButton, IconFilter, IconInfo } from '@lmig/lmds-react-icons';
import { Card } from '@mui/material';
import './FilterCard.scss';
import { Popover } from '@lmig/lmds-react-popover';

export interface FilterCardProps {
  filters: [];
  filterFunction: ([]) => {};
  activeFilters: string;
}

export const FilterCard: any = ({ list = [], filterFunction = ([]) => {}, activeFilters = '' }) => {
  const handleChange = (e: any) => {
    const { value } = e.target;
    filterFunction(value);
  };

  return (
    <Card className="filter-tile">
      <GridRow>
        <div className="filter-title">
          <GridCol base={8}>
            <IconFilter size="16" />
            <span className="filter-card-title">Activity type</span>
            <Popover
              className="filter-tooltip-popover"
              flexWidth
              align="start"
              direction="above"
              variant="inlineIcon"
              trigger={
                <IconButton background="transparent">
                  <IconInfo size="16" color="teal" />
                </IconButton>
              }
            >
              Maximum results displayed up to 50.
              <br />
              Select "All recent activity" to see more.
            </Popover>
          </GridCol>
        </div>
      </GridRow>
      <div className="filter-menu">
        <CheckboxGroup onChange={handleChange}>
          {list.map(([value, count]: [string, number]) => {
            return (
              <Checkbox value={value} labelVisual={`${value} (${count})`} checked={activeFilters.includes(value)} />
            );
          })}
        </CheckboxGroup>
      </div>
    </Card>
  );
};
